import type React from 'react'

import type { Application } from '@/types/Activity'

import OrganisationFallback from './OrganisationFallback'
import OrganisationFinanceDetails from './OrganisationFinanceDetails'

interface Props {
  application: Application
}

const NotForProfitOrganisationDetails: React.FC<Props> = ({ application }) => {
  return (
    <div>
      {application.context?.company?.finance ? (
        <OrganisationFinanceDetails finance={application.context?.company?.finance} />
      ) : (
        <OrganisationFallback
          hasVerifiedOrganisation={
            application.context?.company?.verification?.verifiedBy !== undefined
          }
        />
      )}
    </div>
  )
}

export default NotForProfitOrganisationDetails
